/**
 * For a control that disappears on the first click of a double click: the
 * second used to land on the parcel map, whose double click adds the parcel
 * under it. Called as the control goes; the next click of the user's own is
 * left alone.
 */

const DOUBLE_CLICK_EVENTS = ['mousedown', 'mouseup', 'click', 'dblclick'];

export function dropRestOfDoubleClick() {
    const stop = () => DOUBLE_CLICK_EVENTS.forEach((type) => window.removeEventListener(type, drop, true));

    function drop(event) {
        // A press of the user's own counts from 1; only the rest of that double click is 2.
        if (event.detail < 2) {
            stop();

            return;
        }

        event.stopPropagation();
        event.preventDefault();

        if (event.type === 'dblclick') stop();
    }

    DOUBLE_CLICK_EVENTS.forEach((type) => window.addEventListener(type, drop, true));
}
